import { postJson } from './http';

// One thumbs-up/down (plus an optional comment) on a single assistant response.
// Fields are camelCase here for the frontend; the wire body below matches the AI
// service's FeedbackBody, which aliases only `sessionId` and otherwise expects
// snake_case. `conversationId` is the client-generated assistant message id -- the
// backend does a raw put_item keyed (session_id, conversation_id), so re-submitting
// for the same response upserts the latest verdict. `createdAt` is server-defaulted.
export interface SubmitFeedbackArgs {
  sessionId: string;
  conversationId: string;
  userQuery: string;
  llmResponse: string;
  isPositive: boolean;
  comment?: string;
}

export async function submitFeedback(args: SubmitFeedbackArgs): Promise<void> {
  await postJson(
    '/feedback',
    {
      sessionId: args.sessionId,
      conversation_id: args.conversationId,
      user_query: args.userQuery,
      llm_response: args.llmResponse,
      is_positive: args.isPositive,
      // Omit an empty comment rather than sending "" so the row stays null-clean.
      ...(args.comment ? { comment: args.comment } : {}),
    },
    'submit feedback'
  );
}
